'use client';

import { ComponentPropsWithoutRef } from 'react';
import dynamic from 'next/dynamic';
import classNames from 'classnames';
import './emoji-view.css';

const Emoji = dynamic(() => import('emoji-picker-react').then((module) => module.Emoji), {
  ssr: false,
});

interface EmojiViewProps extends ComponentPropsWithoutRef<'div'> {
  unified: string;
  className?: string;
}

export function EmojiView({ unified, className, ...props }: EmojiViewProps) {
  return (
    <div data-unified={unified} className={classNames('emoji-view', className)} {...props}>
      <Emoji unified={unified} />
    </div>
  );
}
